export default "__VITE_ASSET__DGZ0RYsC__"